module.exports = __webpack_public_path__ + "images/emoji/triumph.4e28b2ab714398a80175.png";